export default __webpack_public_path__ + "static/feature_home_1_img_4-31c786186b9b47fe40b118d607f73dba.png";